<script setup>
definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Terminal";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];

const route = useRoute();
const router = useRouter();

const navigationTab = ref("Index");
const tabItems = ["Index", "Import"];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }}</h4>
  <VCard>
    <VTabs v-model="navigationTab">
      <VTab v-for="item in tabItems" :key="item">
        {{ item }}
      </VTab>
    </VTabs>
    <VWindow v-model="navigationTab">
      <VWindowItem :key="tabItems[0]">
        <TerminalIndex />
      </VWindowItem>
      <VWindowItem :key="tabItems[1]">
        <TerminalImport />
      </VWindowItem>
    </VWindow>
  </VCard>
</template>
